import styled from '@emotion/styled';

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  padding: 35px;
  gap: 35px;
`;
